import API_URLS from '../links';

export const getPendingPayments = (creds,gymId) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.GET_PENDING_PAYMENT + `/${gymId}`, {
        method: 'GET',
        headers: {
          access_token: creds.access_token
        }
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};
